import utils from '../utils'

export const emptyValues = state => {
  state.values = {}
}

export const setData = (state, data) => state.data = data

export const values = state => {
  state.values = utils.cloneObject(state.node.data)
}

export const clone = state => {
  state.values = utils.cloneObject(state.node.data)
  state.values.channel = []
}

export const context = (state, context) => {
  state.context = context
}

export const node = (state, node) => {
  state.node = node
  if (state.nodeType == 'station') {
    state.stationNode = node
  }
}

export const nodeType = (state, nodeType) => {
  state.nodeType = nodeType
}

export const locationDefault = state => {
  let keys = ['latitude', 'longitude', 'altitude']
  for (let k of keys) {
    state.values[k] = Object.assign({}, state.stationNode.data[k])
  }
}

export const setId = (state, id) => state.seed = id

export const incrementId = state => state.seed++

export const addNode = (state, payload) => {
  // payload = { container, newNode }
  payload.container.push(payload.newNode)
}

export const deleteNode = (state, payload) => {
  // payload = { container, node }
  let index = payload.container.indexOf(payload.node)
  payload.container.splice(index, 1)
}

export const edit = (state, newLabel) => {
  state.node.label = newLabel
  state.node.data = utils.cloneObject(state.values)
}

export const schema = state => {
  let sch = state.schemaCollection[state.nodeType]
  if (sch != null) {
    sch = utils.cloneObject(sch)
    if (state.nodeType == 'channel_collection') {
      let schProp = sch.properties
      schProp.network.enum = state.data.network.map(
        x => ({ label: x.label, key: x.id })
      )
      schProp.location.enum = state.stationNode.location.map(
        x => ({ label: x.label, key: x.id })
      )
      if (schProp.network.enum.length > 0) {
        schProp.network.default = schProp.network.enum[0].key
      }
      if (schProp.location.enum.length > 0) {
        schProp.location.default = schProp.location.enum[0].key
      }
    }
    state.schema = sch
  } else {
    console.warn('No schema found for node type: '+state.nodeType)
  }
}

export const inventory = (state, inv) => {
  // set softwareFilters
  state.softwareFilters = inv.software_digital_filter
  state.softwareFilters.sort()

  // set deviceInventory
  state.deviceInventory = utils.multidevice2DeviceInventory(inv.multi_device)

  // build devicesSchema
  let schProp = state.schemaCollection.devices.properties
  let devInv = state.deviceInventory
  schProp.sensor.enum = devInv.sensor.children
  schProp.digitizer.enum = devInv.digitizer.children
  schProp.digital_filter.items.enum = devInv.digital_filter.children
  schProp.analog_filter.items.enum = devInv.analog_filter.children
}
